var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"block-link",attrs:{"href":_vm.url}},[_c('span',{staticClass:"block-link__ic icon-arrow-long"}),_c('span',{staticClass:"block-link__ic icon-arrow-small"}),_c('span',{staticClass:"block-link__text ds-caption ds-caption--size_sm"},[_vm._v(_vm._s(_vm._('Back to catalog')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }